import React from 'react';
import { useEffect, useRef, useState } from 'react';
import { Timeline, Tooltip } from 'antd';
import subwayArrow from '@/assets/subway-arrow.png';
import chooseChecked from '@/assets/choose-checked.png';
import chooseCheckA from '@/assets/choose-check-a.png';
import chooseCheckB from '@/assets/choose-check-b.png';
import styles from './index.module.less';

const iconMap = {
  1: chooseChecked,
  2: chooseCheckA,
  3: chooseCheckB,
}
const colorMap = {
  1: 'rgba(0, 100, 255, 0.5)',
  2: 'rgba(0, 100, 255, 1)',
  3: 'rgba(87, 88, 89, 1)'
}
const statusMap = {
  'COMPLETE': 1,
  'IN_PROGRESS': 2,
  'NOT_START': 3
}

export default function WorkProcess ({ basicInfo = [] })  {
  const [workData, setWorkData] = useState([]);

  useEffect(() => {
    const formatList: any = [];
    basicInfo.forEach((info: any) => {
      formatList.push({
        id: info?.id,
        name: info?.name,
        stage: statusMap[info?.status]
      });
    });
    setWorkData(formatList);
  }, [basicInfo]);

  return (
    <div style={{
      display: 'flex',
      marginTop: '20px',
      minHeight: '34px',
      fontWeight: 500,
      fontSize: '12px',
      lineHeight: '18px'
    }}>
      {
        workData.map((item, index) => (
          <div style={{ width: `calc(${100 / workData.length}%)`, backgroundColor: item.stage === 3 ? 'rgba(247, 248, 250, 1)' : 'rgba(240, 246, 255, 1)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: `${colorMap[item.stage]}`, position: 'relative', paddingRight: '15px'}}>
            {index !== 0 && <img style={{ position: 'relative', left: 0, top: 0, bottom: 0, height: '100%', width: '12px' }} src={subwayArrow}></img>}
            <div style={{ padding: '7px 0', display: 'flex', alignItems: 'center'}}>
              <img style={{ width: 16, height: 16, marginLeft: '2px', marginRight: '5px' }} src={iconMap[item.stage]} />
              <span>{ item.name }</span>
            </div>
          </div>
        ))
      }
    </div>
  )
}